export default __webpack_public_path__ + "static/media/Relacionamentos (Real Size).539053ec.svg";